import React from 'react'

import {PageProps} from '@helios/shared/types/page-props'

type Props = Omit<PageProps, 'children'>

const PageInfoContext = React.createContext<Props>({
    pageContext: {},
} as Props)

export const PageInfoProvider: React.FC<Props> = ({children, ...props}) => (
    <PageInfoContext.Provider value={props}>{children}</PageInfoContext.Provider>
)

export const usePageInfo = () => React.useContext(PageInfoContext)
